import { defineMessages } from "react-intl";
import { loyaltyTagCommonMessages } from "../common.messages";

export const loyaltyTagEditMessages = defineMessages({
  ...loyaltyTagCommonMessages,
  title: {
    id: "loyaltyTagEdit.title",
    defaultMessage: "Preferences",
  },
  icon: {
    id: "loyaltyTagEdit.icon",
    defaultMessage: "Icon",
  },
});
